'use client';

import React from 'react';

import {
  buildScrollTargetAttributes,
  ScrollTargetConfig,
} from '@web-catalog/components/ScrollTarget/scrollUtils';

export type Props = React.PropsWithChildren<
  {
    children?: React.ReactNode;
    hideBlock?: boolean;
  } & ScrollTargetConfig
>;

export const ScrollTarget: React.FC<Props> = ({
  hideBlock,
  eventName,
  scrollDepth,
  threshold,
  children,
  additionalLogData,
}) => {
  const scrollTargetAttrs = buildScrollTargetAttributes({
    eventName,
    scrollDepth,
    threshold,
    additionalLogData,
  });

  if (hideBlock) {
    return null;
  }

  return <div {...scrollTargetAttrs}>{children}</div>;
};
